import { Component, OnDestroy } from "@angular/core";
import { ActiveModal } from "@healthcatalyst/cashmere";
import { Subject, takeUntil } from "rxjs";
import { DocumentService } from "src/app/shared/services/document.service";
import { FullImageElement } from "src/app/shared/services/catalog.service";

/** Displays uploaded screenshots  */
@Component({
    selector: "lightbox",
    templateUrl: "./lightbox.component.html",
    styleUrls: ['./lightbox.component.scss']
})
export class LightboxComponent implements OnDestroy {
    private unsubscribe = new Subject<void>();
    imgLoadFail = false;
    imgLoading = true;
    img : FullImageElement; 
    imgData = '';
    
    constructor(
        private activeModal: ActiveModal,
        private documentService: DocumentService 
    ) {
        this.img = this.activeModal.data.img;
        this.getImage();
    }

    getImage(): void {
        this.imgLoading = true;
        this.imgLoadFail = false;

        this.documentService
                    .getImage(this.img.uploadID)
                    .pipe(takeUntil(this.unsubscribe))
                    .subscribe(
                        data => {
                            this.imgData = window.URL.createObjectURL(data);
                            this.imgLoadFail = false;
                            this.imgLoading = false;
                        },
                        error => {
                            this.imgLoadFail = true;
                            this.imgLoading = false;
                            console.log(error);
                        }
                    );
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}